const normalizeDirection = (direction) => (String(direction || 'asc') === 'desc' ? 'desc' : 'asc');

const toComparable = (value) => {
  if (value === null || value === undefined) {
    return '';
  }

  if (typeof value === 'string') {
    return value.trim();
  }

  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : 0;
  }

  if (typeof value === 'boolean') {
    return value ? 1 : 0;
  }

  return String(value).trim();
};

const compareValues = (left, right, direction) => {
  const modifier = normalizeDirection(direction) === 'desc' ? -1 : 1;

  if (typeof left === 'number' && typeof right === 'number') {
    return (left - right) * modifier;
  }

  const leftString = String(left || '');
  const rightString = String(right || '');
  return leftString.localeCompare(rightString, 'es', { sensitivity: 'base' }) * modifier;
};

export const resolveSortChange = (currentSort, nextSortPayload, allowedFields = []) => {
  const currentField = String(currentSort?.field || '').trim();
  const currentDirection = normalizeDirection(currentSort?.direction);
  const nextField = String(nextSortPayload?.field || '').trim();

  if (!nextField) {
    return { field: currentField, direction: currentDirection };
  }

  if (Array.isArray(allowedFields) && allowedFields.length > 0 && !allowedFields.includes(nextField)) {
    return { field: currentField, direction: currentDirection };
  }

  return {
    field: nextField,
    direction: normalizeDirection(nextSortPayload?.direction),
  };
};

export const resolveSortIconClass = (currentSort, field) => {
  const currentField = String(currentSort?.field || '').trim();
  const normalizedField = String(field || '').trim();

  if (currentField !== normalizedField) {
    return 'fa-sort';
  }

  return normalizeDirection(currentSort?.direction) === 'desc' ? 'fa-sort-desc' : 'fa-sort-asc';
};

export const resolveSortTogglePayload = (currentSort, field, allowedFields = []) => {
  const requestedField = String(field || '').trim();
  if (requestedField === '') {
    return null;
  }

  if (Array.isArray(allowedFields) && allowedFields.length > 0 && !allowedFields.includes(requestedField)) {
    return null;
  }

  const currentField = String(currentSort?.field || '').trim();
  const currentDirection = normalizeDirection(currentSort?.direction);
  const nextDirection = currentField === requestedField && currentDirection === 'asc' ? 'desc' : 'asc';

  return {
    field: requestedField,
    direction: nextDirection,
  };
};

export const sortRows = (rows, sortState, valueResolvers = {}) => {
  const list = Array.isArray(rows) ? [...rows] : [];
  const sortField = String(sortState?.field || '').trim();
  const sortDirection = normalizeDirection(sortState?.direction);

  if (!sortField) {
    return list;
  }

  const resolveValue = typeof valueResolvers?.[sortField] === 'function'
    ? valueResolvers[sortField]
    : (row) => row?.[sortField];

  return list.sort((left, right) => {
    const leftValue = toComparable(resolveValue(left));
    const rightValue = toComparable(resolveValue(right));

    return compareValues(leftValue, rightValue, sortDirection);
  });
};
